var Gdpr = (function () {
    const BUTLER_LINK = "https://gepard.svc.avast.com/v1/";

    var urlToken,
        refreshToken,
        translationObj = $("#translationObj").data("translations"),
        gdprPortalParameters = $("#gdpr-portal").data("parameters"),
        gdprBrand = gdprPortalParameters.brand.match("www.[a-z]*.(com|ru|ua)")[0].split(".")[1].toUpperCase(),
        loader = $(".loading"),
        isInputsChanged = false,
        originalEmail,
        json = {},
        updatedJson = {};

    // options with butler calls
    var butlerOption = {
        // get data from butler
        "getData": function () {
            return butlerCall("getData", "", "GET")
        },
        // for update personal data form
        "update": function (jsonData, createFormAfterUpdate) {
            butlerCall("update", "personal-information", "POST", jsonData, createFormAfterUpdate)
        },
        // for export all json data to file
        "export": function () {
            butlerCall("export", "export", "GET")
        },
        // for sent login link to gdpr portal
        "verify": function (jsonData) {
            butlerCall("verify", "verify", "POST", jsonData)
        },
        // for change email in personal data form
        "verifyNewEmail": function (jsonData, token) {
            butlerCall("verifyNewEmail", "verify-new-email", "POST", jsonData)
        },
        // for verification new/changed email
        "verifyToken": function (token) {
            butlerCall("verifyToken", "verify-token", "GET")
        }
    };

    var butlerCall = function (butlerAction, actionLink, ajaxMethod, jsonData, createFormAfterUpdate) {
        dataToButler = jsonData ? JSON.stringify(jsonData) : "",

            $.ajax({
                url: butlerAction === "verifyToken" ? BUTLER_LINK + actionLink + "/" + urlToken : BUTLER_LINK + actionLink,
                method: ajaxMethod,
                contentType: "application/json",
                data: dataToButler,
                headers: {
                    "X-AUTHORIZATION": refreshToken
                },
                beforeSend: function () {
                    loader.removeClass("hide");
                },
                success: function (result, status, xhr) {
                    // save refresh_token from response header to local storage and to refreshToken variable
                    refreshToken = xhr.getResponseHeader("refresh_token");
                    saveDataToLocalStorage(urlToken, refreshToken);

                    butlerSuccessResponse(butlerAction, result, createFormAfterUpdate);
                },
                error: function (xhr, status, error) {
                    butlerErrorResponse(xhr, status, error, butlerAction);
                },
                complete: function () {
                    loader.addClass("hide");
                }
            });
    };

    // If Butler response is 200
    var butlerSuccessResponse = function (butlerAction, data, createFormAfterUpdate) {
        // if response is not empty
        if (data) {

            if (butlerAction === "verify") {
                if (data.status === "OK") {
                    dataLayer.push({'event': 'formCompleted'}); // tracking login form
                    openColorBox("#check-email_content");
                } else if (data.status === "NOT_FOUND") {
                    openColorBox("#user-not-found_content");
                }
                grecaptcha.reset();
            } else if (butlerAction === "getData") {
                // asign user data to json variable
                json = data;

                createHtml(json);
                // after succes login add "#personal-data" hash to url
                location.hash = "personal-data";
            } else if (butlerAction === "update") {
                // replace old json data with new data
                json = data;

                // when change email and send updated data to butler -> create form with updated data
                if (createFormAfterUpdate) {
                    openColorBox("#personal-data-changed_content");
                    createHtml(json);
                } else {
                    // update inputs in personal data
                    updatePersonalData(json);
                    openColorBox("#personal-data-changed_content");
                }

            } else if (butlerAction === "export") {
                exportData(data);
            } else if (butlerAction === "verifyNewEmail") {
                if (data.status === "OK") {
                    // if response is OK, save all changed inputs to local storage
                    saveDataToLocalStorage(originalEmail, JSON.stringify(updatedJson));

                    openColorBox("#verify-email_content");
                } else if (data.status === "NOT_ALLOWED") {
                    openColorBox("#change-email-is-not-allowed_content");
                }
            } else if (butlerAction === "verifyToken") {
                // verification changed email
                // verify if local storage with old email value as key is exist and have same value like email from verify token
                if (data.valid || data.email === loadDataFromLocalStorage(data.email)) {
                    // sent update all changed inputs to butler
                    butlerOption.update(JSON.parse(loadDataFromLocalStorage(data.email)), true);
                }
            }
        } else {
            $("body").removeClass("logged-in").addClass("not-logged-in");

            openColorBox("#global_error_content");
        }
    };

    var butlerErrorResponse = function (xhr, status, error, butlerAction) {
        if (xhr.responseText) {
            var dataResponseText = JSON.parse(xhr.responseText);
        }
        if (xhr.status === 400) {
            if (dataResponseText.errorCode === 2002) {
                openColorBox("#update-data-in-process_content");
            } else if (dataResponseText.errorCode === 2001) {
                openColorBox("#change-email-is-not-allowed_content");
            } else if (dataResponseText.errorCode === 9001) {
                $("body").removeClass("logged-in").addClass("not-logged-in");
                openColorBox("#no-data-found_content");
            } else {
                openColorBox("#global_error_content");
            }
        } else if (xhr.status === 401) {
            // invalid or expired token
            $("body").removeClass("logged-in").addClass("not-logged-in");
            openColorBox("#session-expired_content");
        } else {
            if (butlerAction === "verify") {
                grecaptcha.reset();
            } else if (butlerAction === "getData") {
                $("body").removeClass("logged-in").addClass("not-logged-in");
                openColorBox("#session-expired_content");
            }
        }
    };

    // export all data
    var exportData = function (jsonData) {
        var dataString = JSON.stringify(jsonData);
        var blob = new Blob([dataString], {type: "text/plain"});
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.download = "export.json";
        link.click();
        window.URL.revokeObjectURL(link.href);
    };

    // save data to local storage
    var saveDataToLocalStorage = function (storageKey, storageValue) {
        localStorage.setItem(storageKey, storageValue);
    };

    // load data from local storage
    var loadDataFromLocalStorage = function (storageKey) {
        return localStorage.getItem(storageKey);
    };

    // validate form inputs
    var validateFormInput = function (inputId) {
        var input = $("#" + inputId),
            isValid = true,
            validationRegex = {
                "noEmpty": ".",
                "noDigit": "^([^0-9]*)$",
                "noValidEmail": "^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"
            };

        input.parents(".form-group").removeClass("alert").find(".errors").remove();
        $.each(input.data("validation-options"), function (index, value) {
            if (new RegExp(validationRegex[value]).test(input.val()) === false && isValid !== false) {
                input.parents(".form-group").addClass("alert");
                input.after("<ul class='errors'><li>" + translationObj["validation_" + value] + "</li></ul>");
                isValid = false;
            }
        });
        return isValid;
    };

    // check if update status is set
    var getStatus = function () {
        return json.status.update;
    };

    /**
     * show update status message
     **/
    var showStatusMessage = function () {
        if (json.status.update) {
            $("#status-message").html(translationObj.statusUpdate);
        }

        $(".status-info").removeClass("hide");
    };

    // fill personal data from json
    var fillPersonalData = function (jsonData) {
        var status = getStatus();

        if (status) {
            showStatusMessage();
        }

        $.each(jsonData, function (inputKey, inputValue) {
            // use as key of local storage when user change email
            if (inputKey === "email") {
                originalEmail = inputValue;
            }

            // / set country name depends on country ISO code
            if (inputKey === "country_code") {
                $("#country, #country_code").val(inputValue).prop("disabled", status);
            } else {
                // fill other inputs
                $("#personal_data").find("#" + inputKey).val(inputValue).prop("disabled", status);
            }

        });
        // disable submit button
        $("#personal_data input[type=submit]").prop("disabled", true);

        // disable countryLIst is status set
        $("#countryList").prop("disabled", status);
    };

    var updatePersonalData = function (updatedJson) {
        var status = getStatus();
        $.each(updatedJson.personal_data.personal, function (inputKey, inputValue) {
            if (inputKey === "country_code") {
                $("#country, #country_code").val(inputValue).prop("disabled", status);
            } else {
                $("#personal").find("#" + inputKey).val(inputValue).prop("disabled", status);
            }
        });

        // disable submit button
        $("#submit-save-changes").prop("disabled", true);
    };

    var createHtml = function (data) {
        //load support form and fill it
        $("#support-contact-form").load("gdpr-form", function () {
            initAvastForm();
            fillSupportForm();
        });

        $.each(data, function (key, value) {
            if (key === "personal_data") {
                createPersonalData(value);
            } else if (key === "product_consent" || key === "email_consent") {
                createOtherConsents(key, value);
            }
        });

        function createPersonalData(data) {
            $.each(data, personalDataRecurse);

            function personalDataRecurse(key, val) {
                //fill #personal_data inputs with values from json
                if (key === "personal") {
                    fillPersonalData(val);

                } else if (key === "others") {
                    createOthersPersonalData(key, val);
                }
            }
        }

        function createOtherConsents(parentElement, data) {

            var html = '';
//                index = 0;

            $.each(data, function (consentsKey, consentsValue) {
                if (consentsValue[0] && Object.keys(consentsValue[0].consents[0]).length > 0 || typeof consentsKey === 'number' && consentsValue.devices && Object.keys(consentsValue.devices).length > 0) {
                    html += "<div class='box narrow'>";
                    if (parentElement === "product_consent") {
                        html += "<div class='top'><h3 class='product-name'>" + consentsValue.productName + "</h3></div>";
                    } else if (parentElement === "email_consent") {
                        html += "<div class='top'><div class='brand brand-" + consentsKey + "'><h3 class='brand-name'>" + translationObj["brand"] + ": " + consentsKey + "</h3></div></div>";
                    }
                    html += "<div class='box-content'>";
                    $.each(consentsValue, dataRecurse);
                    html += "</div></div></div>";
                    $("#" + parentElement).html(html);
                    // index++;
                }
            });

            function dataRecurse(recurseKey, recurseValue) {
                if (recurseValue && recurseValue['deviceName']) {
                    var recurseValueOrdered = {};
                    recurseValueOrdered.deviceName = recurseValue.deviceName;
                    recurseValueOrdered.consents = recurseValue.consents;
                    recurseValue = recurseValueOrdered;
                }
                if (recurseValue instanceof Object) {
                    if (recurseKey === "devices" && Object.keys(recurseValue).length === 0) {
                        html += "<p class='message'>" + translationObj.empty_consents + "</p>";
                    }
                    $.each(recurseValue, dataRecurse);

                } else {

                    if (parentElement === "email_consent") {
                        if (recurseKey === "email") {
                            html += "<div class='email email-icon'><svg class='icon icon-mail' viewBox='5 0 25 25' xmlns='http://www.w3.org/2000/svg'><path id='ico' d='M18,17.16H7c-0.83,0-1.5-0.67-1.5-1.5l0,0V7.41c0-0.83,0.67-1.5,1.5-1.5h11c0.83,0,1.5,0.67,1.5,1.5v8.25C19.5,16.48,18.83,17.16,18,17.16L18,17.16z M7,15.66h11V9.7l-5.02,3.53c-0.29,0.24-0.7,0.24-0.99,0L7,9.72V15.66z M7,7.41v0.55C7.03,7.97,7.06,7.98,7.09,8l5.4,3.78L17.88,8c0.04-0.02,0.08-0.04,0.12-0.05V7.41H7z'/></svg>" + recurseValue + "</div>";
                        }
                    } else if (parentElement === "product_consent") {
                        if (recurseKey === "deviceName") {
                            html += "<p class='device-name'>" + translationObj.device + ": " + recurseValue + "</p>";
                        }
                        if (recurseKey === "brand") {
                            html += "<p class='brand'>" + translationObj.brand + ": " + recurseValue + "</p>";
                        }
                    }

                    if (typeof recurseValue === "boolean") {

                        var consentName = translationObj[recurseKey],
                            symbol = recurseValue ? "icon-check" : "icon-cross";
                        // info icons in product consents
                        if (parentElement === "product_consent") {
                            html += "<div class='consent'><span class='consent-name js-info'>" + consentName + "<span class='js-infotext infotext'>" + translationObj[recurseKey + "_tooltip"] + "</span><span class='info visible'></span></span><span class='consent-icon " + symbol + "'></span></div>";
                        } else {
                            html += "<div class='consent'><span class='consent-name'>" + consentName + "<span class='consent-icon " + symbol + "'></span></div>";
                        }
                    }
                }
            }

            $("body").removeClass("not-logged-in").addClass("logged-in");
        }

        $("body").removeClass("not-logged-in").addClass("logged-in");
    }

    // create other personal information
    var createOthersPersonalData = function (parentEl, data) {
        var html = "",
            inputNumber = 0,
            showOtherPersonalData = false,
            isOtherEmails = false,
            gridClasses,
            divPersonalInformations = $("#personal-informations"),
            divOthersPersonalInformations = $("#other-informations");


        $.each(data, function (k, v) {
            dataRecurse(k, v, true);
        });

        function dataRecurse(key, val, isFirst) {
            // if json have some others_informations
            // if not, hide whole #other-informations div
            if (val !== null && val.length !== 0) {

                if (!showOtherPersonalData) {
                    showOtherPersonalData = true;
                }

                if (val instanceof Object) {
                    isOtherEmails = key === "other_emails" ? true : false;

                    var title = "<div class='question item-title'><h4 class='title'>" + translationObj[key] + "</h4><span class='collapse-expand-round-button'></span></div>";

                    html += isFirst ? "<div class='other " + key + " collapsible'>" + title + "<div class='more-info'>" : "<div class='more-info-group'>";

                    $.each(val, dataRecurse, false);

                    html += isFirst ? "</div></div>" : "</div>";
                } else {
                    var inputType = isOtherEmails ? "email" : "text";

                    // don't show country code in other information section
                    if (val && val !== "null" && key !== "country_code") {
                        key = isOtherEmails ? "email" : key;

                        var keyWithNumber = key + "_" + inputNumber;
                        html += "<div class='form-group'><label for='" + keyWithNumber + "'>" + translationObj[key] + "</label><div class='form-input'><input type='" + inputType + "' name='" + key + "' id='" + keyWithNumber + "' value='" + val + "' disabled></div></div>";
                    }
                    inputNumber++;
                }
            }
        }

        // show other personal data if exist in json, depending on brand
        if (showOtherPersonalData) {
            $("#" + parentEl).html(html);

            if (gdprBrand === "AVAST") {
                gridClasses = "span6";
            } else if (gdprBrand === "AVG") {
                gridClasses = "col-md-6 text-md-left text-center";
            } else if (gdprBrand === "HIDEMYASS") {
                gridClasses = "col m-12 t-6";
            }
            divPersonalInformations.removeClass().addClass(gridClasses);
            divOthersPersonalInformations.removeClass("hide");
        }
    };

    // fill contact support form
    var fillSupportForm = function () {
        var $supportForm = $('#support-contact-form');
        $supportForm.find('input[name="firstName"]').val(json.personal_data.personal.first_name);
        $supportForm.find('input[name="lastName"]').val(json.personal_data.personal.last_name);
        $supportForm.find('input[name="email"], input[name="hiddenEmail"]').val(json.personal_data.personal.email);
    };

    // add auth token to links in lng selectors
    var addToken = function(parentEl, lngEl) {
        $(parentEl + ' ' + lngEl).each(function(index) {
            this.href = this.href + "?auth=" + urlToken;
        });
    };

    // colorbox
    var openColorBox = function (contentId) {
        $.colorbox({
            href: contentId,
            maxWidth: '700px',
            width: "95%",
            initialHeight: '180px',
            inline: true,
            opacity: 0.3,
            reposition: true,
            onComplete: function () {
                $(contentId).removeClass("hide");
                $.colorbox.resize();
            },
            onClosed: function () {
                $(contentId).addClass("hide");
            }
        });
        // resize colorbox on resize window
        $(window).resize(function () {
            if (window.innerWidth < 768) {
                $.colorbox.resize({
                    width: '95%'
                });
            }
        });
    };

    return {
        openColorBox: function (colorboxContent) {
            openColorBox(colorboxContent);
        },
        fillSupportForm: function () {
            fillSupportForm();
        },
        init: function () {

            var changedInputsList = {},
                $menu = $('.js-menu'),
                $navigation = $('.js-navigation'),
                url = new URL(window.location);

            if (!urlToken) {
                urlToken = avm.require("avast.url.unserialize")(window.location.href)["auth"] ? avm.require("avast.url.unserialize")(window.location.href)["auth"] : avm.require("avast.url.unserialize")(window.location.href)["verify"];
            }

            if(urlToken) {
                 // add auth token to lng selector links
                 if(gdprBrand === "AVAST" && $('#bottom-links').length > 0) {
                    addToken('.possible-lang', 'li a');
                } else if (gdprBrand === "AVG" && $('#language-selector').length > 0) {
                    addToken('.country-item', 'a');

                    // for modal-footer links
                    if ($('.modal-footer').length > 0) {
                        addToken('.modal-footer', 'a');
                    };
                } else if (gdprBrand === "HIDEMYASS" && $('#lang-selector').length > 0) {
                    addToken('#lang-selector', 'a.bi-nav-language-selector');
                }
            }

            if (avm.require("avast.url.unserialize")(window.location.href)["auth"]) {
                // if user refresh page, check if gdpr-token with new key is available in local storage
                // if gdpr-token exist, set refreshToken from local storage else use token from auth query param
                refreshToken = loadDataFromLocalStorage(urlToken) ? loadDataFromLocalStorage(urlToken) : urlToken;

                butlerOption.getData();
            } else if (avm.require("avast.url.unserialize")(window.location.href)["verify"]) {

                refreshToken = avm.require("avast.url.unserialize")(window.location.href)["verify"];
                butlerOption.verifyToken();

            } else {
                $("body").removeClass("logged-in").addClass("not-logged-in");
            }

            // validate form input on change - validate just input with data-validation
            $("form").on("keyup", "input", function () {
                if ($(this).data("validation")) {
                    validateFormInput(this.id);
                }
            });

            // when change something in personal data form
            $("#personal-form").on("keyup change", "input:not(:hidden), select", function () {
                var elementId = this.id,
                    elementValue = this.value,
                    // for empty inputs butler return null values insted empty strings -> replace null value with empty string
                    jsonElementValue = json.personal_data.personal[elementId] === null ? "" : json.personal_data.personal[elementId];

                if (elementId === "country") {
                    // update country iso code hidden input
                    $("#country_code").val(this.value);
                }

                if (elementValue === jsonElementValue) {
                    delete changedInputsList[elementId];
                } else {
                    changedInputsList[elementId] = elementValue;
                }
                isInputsChanged = Object.keys(changedInputsList).length > 0;

                $("#submit-save-changes").prop("disabled", !isInputsChanged);
            });


            $("#personal-form").on("click", "#submit-save-changes", function (e) {
                e.preventDefault();

                var isFormValid = true;

                // check if all inputs are valid
                $("#personal-form").find("input[data-validation=true]").each(function () {
                    if (validateFormInput(this.id) === false) {
                        isFormValid = false;
                    }
                });

                // if form is not valid scroll to first invalid input
                if (!isFormValid) {
                    $('html, body').animate({
                        scrollTop: $("#personal").find(".form-group.alert").first().offset().top
                    }, 500);
                }

                // if change something in personal form and form is valid
                // save inputs to updatedJson
                if (changedInputsList && isFormValid) {
                    $("#personal .form-group").find("input, select").each(function () {

                        // save country name from country selector to updatedJson
                        if ($(this).is("select")) {
                            updatedJson[this.id] = $("#" + this.id + " option:selected").text();
                        } else {
                            updatedJson[this.id] = this.value;
                        }
                    });

                    if (changedInputsList["email"]) {

                        //replace email in updated json with original email address and create new key "new_email" with new email
                        updatedJson["email"] = originalEmail;
                        updatedJson["new_email"] = changedInputsList["email"];

                        // user change email address - send verification email to new email address
                        butlerOption.verifyNewEmail({
                            "newEmail": changedInputsList["email"],
                            "locale": gdprPortalParameters.locale,
                            "brand": gdprBrand === "HIDEMYASS" ? "HMA" : gdprBrand
                        });
                    } else {
                        // user doesn't change email address - send new data to butler
                        butlerOption.update(updatedJson);
                    }
                }
            });

            // click on request access button (login)
            $("#login-form").submit(function (e) {
                e.preventDefault();

                if (validateFormInput("login_email")) {
                    loader.removeClass("hide");
                    // get user IP address from "global_placeholders_json" CMS file and send login email to butler
                    $.get("global_placeholders_json", function (data) {
                        butlerOption.verify({
                            "email": $("#login_email").val(),
                            "locale": gdprPortalParameters.locale,
                            // rename HIDEMYASS domain name to HMA
                            "brand": gdprBrand === "HIDEMYASS" ? "HMA" : gdprBrand,
                            "ip": data.ip,
                            "recaptchaResponse": grecaptcha.getResponse()
                        });
                    });
                }
            });

            // send export request to butler
            $("#export-personal-data").on("click", function () {
                butlerOption.export();
            });

            // EXPAND/COLLAPSE
            $(".faq-item").on("click", ".question", function () {
                var allButton = $(".expand-collapse-all"),
                    topParentEl = $(this).parents(".box-content"),
                    parent = $(this).parent();

                $(parent).toggleClass("expand");
                $(this).parent().find(".more-info").stop().slideToggle("slow");

                if ($(topParentEl).find(".faq-item.expand").length === $(topParentEl).find(".faq-item").length) {
                    $(topParentEl).find(allButton).addClass("expand").text(translationObj.collapseAll);
                } else {
                    $(topParentEl).find(allButton).removeClass("expand").text(translationObj.expandAll);
                }
            });

            $(".expand-collapse-all").on("click", function () {
                var moreInfoEl = $(this).parent().find(".more-info");
                moreInfoEl.stop();

                if ($(this).hasClass("expand")) {
                    $(this).removeClass("expand").text(translationObj.expandAll);
                    $(moreInfoEl).parent().removeClass("expand");
                    moreInfoEl.slideUp("slow");
                } else {
                    $(this).addClass("expand").text(translationObj.collapseAll);
                    $(moreInfoEl).parent().addClass("expand");
                    moreInfoEl.slideDown("slow");
                }
            });

            // personal data other informations expand/collapse
            $("#other-informations").on("click", ".collapsible .item-title", function () {
                $(this).parent().toggleClass("expand");
                $(this).parent().find(".more-info").stop().slideToggle("slow");
            })
            // END EXPAND/COLLAPSE

            // COLORBOX //
            $(".cbox-close").on("click", function () {
                $.fn.colorbox.close();
            });
            // END COLORBOX

            // TOOLTIPS //
            $(".gdpr-container").on({
                "mouseenter": function () {
                    // row with info icon in on privacy preferences tab
                    var $entry = $(this),
                        $infotext = $(this).parent().find(".js-infotext");

                    $infotext.css({
                        position: "absolute",
                        top: $entry.outerHeight() + 20 + "px",
                        left: ($entry.outerWidth() / 2) - ($infotext.outerWidth(true) / 2)  + "px"
                    }).show();
                },
                "mouseleave": function () {
                    $('.js-infotext').hide();
                }
                // show just on element without disabled prop
            }, ".js-info:not(:disabled)");
            // END TOOLTIPS

            // NAVIGATION //
            $(".navigation").on("click", "a[data-show-target]", function (e) {
                //e.preventDefault();
                $(".navigation-button").removeClass("active");
                $(this).addClass("active");

                $(".page-section").addClass("hide");
                $("#" + $(this).data("show-target")).removeClass("hide");
            });

            // Hamburger opens mobile navigation
            $('.js-hamburger').on('click', function (e) {
                e.preventDefault();
                $navigation.removeClass('hide-nav').addClass('show-nav');
                $menu.removeClass('bounceout fadeout').addClass('bouncein fadein');
            });

            // X closes mobile navigation
            $('.js-navigation-close').on('click', function (e) {
                e.preventDefault();
                $navigation.removeClass('show-nav').addClass('hide-nav');
                //$header.toggleClass('hide');
                $menu.removeClass('bouncein fadein').addClass('bounceout fadeout');
            });

            // close navigation menu on mobile devices when click on navigation item
            $(".navigation").on("click", ".fadein .navigation-button", function () {
                $('.js-navigation-close').trigger("click");
            });
            // END NAVIGATION //
        }
    }
})();

$(document).ready(function () {
    Gdpr.init();
});

// support form - show response message.
// Reload form on success response
function gdpr(data, form) {
    if (data.status === "ok") {
        dataLayer.push({'event': 'formCompleted'}); // tracking
        Gdpr.openColorBox("#support-form-success_content");
        $("#support-contact-form").load("gdpr-form", function () {
            initAvastForm();
            Gdpr.fillSupportForm();
        });
    } else {
        Gdpr.openColorBox("#support-form-error_content");
    }
};

// recaptcha callback
function recaptcha_callback() {
    $("#request-access").prop("disabled", false);
}

// recaptcha expired callback
function recaptchaExpired() {
    $("#request-access").prop("disabled", true);
}
